import { RequestTableColumnsActionTypes, RequestTableColumnsState, SET_REQUEST_TABLE_COLUMNS } from 'store/reducers/lodgingRequest/request-table-columns/types';

const defaultState: RequestTableColumnsState = {
  isLoading: false,
  errorMessage: '',
  contents: ['requestDate', 'corporateClientName', 'storeNumber', 'guestId', 'guestName', 'requestedStartDate', 'requestedEndDate', 'status', 'reservationId', 'clcRequestNumber', 'lodgingOptionName', 'lodgingOptionAddress', 'actions'],
};

export default function tableColumns(state = defaultState, action: RequestTableColumnsActionTypes): RequestTableColumnsState {
  switch (action.type) {
    case SET_REQUEST_TABLE_COLUMNS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
      };
    default:
      return state;
  }
}
